import React from "react";
import Lottie from "lottie-react";
import styled from "styled-components";

const LottieWrapper = styled("div")({
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  height: "100%",
  zIndex: 1,
  pointerEvents: "none",
  extraStyles: (props) => props.extraStyles,
});

const LottieAnimation = ({
  animationData,
  loop = 1,
  autoplay = true,
  extraStyles = "",
  lottieStyles = {},
}) => {
  return (
    <LottieWrapper extraStyles={extraStyles}>
      <Lottie
        animationData={animationData}
        loop={loop}
        autoplay={autoplay}
        style={{ height: "100%", ...lottieStyles }}
      />
    </LottieWrapper>
  );
};

export default LottieAnimation;
